import { useMutation, useQueryClient } from '@tanstack/react-query';

import { apiClient } from '@cast/infrastructure-api';
import { ClusterAutoscalerPoliciesV2 } from '@cast/types-cluster-autoscaler';

import { getPoliciesV2QueryKey } from '../queries/usePoliciesV2Query';

type Args = {
  clusterId: string;
  policiesV2: ClusterAutoscalerPoliciesV2;
};

export const useUpdatePoliciesV2Mutation = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (args: Args) =>
      apiClient.clusterAutoscaler.updatePoliciesV2({
        clusterId: args.clusterId,
        policiesV2: args.policiesV2,
      }),
    onSuccess: ({ data: updatedPoliciesV2 }, args) => {
      const queryKey = getPoliciesV2QueryKey({ clusterId: args.clusterId });
      queryClient.setQueryData(queryKey, updatedPoliciesV2);
    },
  });
};
